import React from 'react';
import PropTypes from 'prop-types';
import { PhoneCallIcon } from '../../../images';
import { useTranslation } from 'react-i18next';

const EarthlinkPerksCTA = ({ phoneNumber, title, footerText }) => {
  const { t } = useTranslation();
  const resolvedTitle = title || t('products.ctaTitle');
  return (
    <div className="perks-below-slider__ctaRow">
      <div className="perks-below-slider__ctaTitle">
        {resolvedTitle}
      </div>
      <a className="perks-below-slider__btn" href={`tel:${phoneNumber}`}>
        <img src={PhoneCallIcon} alt="Phone Call" /> {phoneNumber}
      </a>
      {footerText && <p className="perks-below-slider__footerText">{footerText}</p>}
    </div>
  );
};

EarthlinkPerksCTA.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  title: PropTypes.string,
  footerText: PropTypes.string,
};

export default EarthlinkPerksCTA;
